
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";

interface TaxiDialogProps {
  showTaxi: boolean;
  setShowTaxi: (show: boolean) => void;
  destinationName: string;
}

export function TaxiDialog({
  showTaxi,
  setShowTaxi,
  destinationName
}: TaxiDialogProps) {
  const { t } = useTranslation();
  
  return (
    <Dialog open={showTaxi} onOpenChange={setShowTaxi}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {t("tripCard.taxiTransfer")} {t("common.in")} {destinationName}
          </DialogTitle>
          <DialogDescription>
            {t("tripCard.taxiTransferDesc")}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4 text-center p-4">
          <p>{t("tripCard.taxiTransferComingSoon")}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
